import React from 'react';
import { Alert, Card, Descriptions, Space, Tag, Typography } from 'antd';
import type { FinanceReadinessProjection } from '../routes/execution/dashboardProjection';
import { financeReadinessTagLabel } from '../routes/execution/financeReadinessFacade';

const { Text } = Typography;

type Props = {
  finance: FinanceReadinessProjection;
};

export const ExecutionFinanceReadiness: React.FC<Props> = ({ finance }) => {
  return (
    <Card size="small" title="Готовность к оплате">
      <Space direction="vertical" style={{ width: '100%' }}>
        <Tag
          color={finance.blocked ? 'error' : finance.allReady ? 'success' : 'processing'}
          style={{ fontSize: 13 }}
        >
          {finance.headline}
        </Tag>
        <Text type="secondary">{finance.detail}</Text>
      </Space>

      {finance.blocked && finance.blockedReasons.length > 0 ? (
        <Alert
          type="error"
          showIcon
          style={{ marginTop: 12 }}
          message="Причины блокировки"
          description={
            <ul style={{ margin: 0, paddingLeft: 18 }}>
              {finance.blockedReasons.map((r) => (
                <li key={r}>{r}</li>
              ))}
            </ul>
          }
        />
      ) : null}

      <Descriptions size="small" column={3} style={{ marginTop: 12 }}>
        <Descriptions.Item label="Счёт">
          <Tag color={finance.invoiceReady ? 'success' : 'default'}>
            {financeReadinessTagLabel(finance.invoiceReady)}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="УПД">
          <Tag color={finance.updReady ? 'success' : 'default'}>
            {financeReadinessTagLabel(finance.updReady)}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Оригиналы">
          <Tag color={finance.originalsReady ? 'success' : 'default'}>
            {financeReadinessTagLabel(finance.originalsReady)}
          </Tag>
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default ExecutionFinanceReadiness;
